import React from 'react';

import clsx from 'clsx';

interface DividerProps {
  text?: string;
  className?: string;
}

const Divider: React.FC<DividerProps> = ({
  text = 'Or continue with',
  className = '',
}) => (
  <div className={clsx('relative mt-10', className)}>
    <div aria-hidden="true" className="absolute inset-0 flex items-center">
      <div className="w-full border-t border-gray-300" />
    </div>
    <div className="relative flex justify-center text-xs font-medium">
      <span className="bg-white px-6 text-gray-600">{text}</span>
    </div>
  </div>
);

export default Divider;
